import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { categories } from "@/mocks/site";

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full bg-background-50 py-14 md:py-20 scroll-mt-[72px]">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionTitle
          eyebrow="Topics"
          title="按主题进入"
          description="六个方向，覆盖网暴从发生到收场的完整链条。你可以从最关心的一环开始读。"
        />

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((item) => (
            <Link
              key={item.slug}
              to={`/cases?category=${encodeURIComponent(item.name)}`}
              className="group p-5 md:p-6 rounded-lg border border-background-200 bg-background-50 hover:border-accent-400 transition-colors cursor-pointer flex flex-col"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800 group-hover:bg-accent-100 group-hover:text-accent-800 transition-colors">
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {item.name}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{item.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-foreground-500 group-hover:text-primary-600 transition-colors">
                进入该主题
                <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}